import { lruMemoize } from 'reselect';

const getColor = lruMemoize(({ backgroundColor, color }: Record<string, string>) => {
  if (backgroundColor) {
    return {
      backgroundColor
    };
  }
  if (color) {
    return {
      color
    };
  }
  return {};
});

// eslint-disable-next-line import/prefer-default-export
export { getColor };
